//import { ThrowStmt } from '@angular/compiler';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AppData } from 'src/app/app.data';
import { AppSettings } from 'src/app/app.settings';
import { Settings } from 'src/app/app.settings.model';
import { ApiResponseCode, PaymentRequestProviders } from 'src/app/core/enums';
import { PaymentService } from 'src/app/core/services/payment.service';
import { ScopeService } from 'src/app/core/services/scope.service';
import { ToastMsgService } from 'src/app/core/services/toast-msg.service';
import { Utils } from 'src/app/core/utils';

@Component({
  selector: 'app-pre-payment-request',
  templateUrl: './pre-payment-request.component.html',
  styleUrls: ['./pre-payment-request.component.scss']
})
export class PrePaymentRequestComponent implements OnInit, AfterViewInit {

  //eventID:number;
  //providerType: string;
  //sub:any;

  submitting = false;
  error: string;
  settings: Settings;
  form: UntypedFormGroup;
  data: any;
  prePaymentData:any;
  provider:any;
  enumProviderTypes = PaymentRequestProviders;
  terminals: [];
  paymentBoxes: [];
  defaultCurrency:any;
  minTotal = 0.0;
  receivePaymentModel:any;
  bitAuthDataID?:number;


  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }
  get diagnostic() { return JSON.stringify(this.form.value); }

  constructor(public appSettings: AppSettings,
    public fb: UntypedFormBuilder,
    public router: Router,
    private route: ActivatedRoute,
    public translate: TranslateService,    
    private adapter: DateAdapter<any>,    
    private scopeService: ScopeService,
    private paymentService: PaymentService,
    private dialog: MatDialog,
    private toastMsg: ToastMsgService,
    private appData: AppData) { 
     
      
      this.settings = appSettings.settings;
      this.data = appData.prePaymentRequestData;  // { terminals, paymentBoxes, model, hasPelecard}
      this.terminals = appData.prePaymentRequestData.terminals || [];
      this.paymentBoxes = appData.prePaymentRequestData.paymentBoxes || [];
      this.prePaymentData = JSON.parse(this.data.model.PrePaymentRequestModel);
      this.provider = this.prePaymentData.Provider;
      this.defaultCurrency = appData.prePaymentRequestData.model.DefaultCurrency;    
      this.receivePaymentModel = appData.prePaymentRequestData.model; // the model to return
      this.bitAuthDataID = this.prePaymentData.BitAuthenticationDataID;
      
    }

  ngOnInit(): void {   

    this.initForm();
  }

  ngAfterViewInit(): void {
     
  }

  initForm(){
    
    // round price
    var total = this.roundPrice(this.prePaymentData.Total);

    if(this.prePaymentData.MaxNumberOfPayments < 1){
      this.prePaymentData.MaxNumberOfPayments = 1;
    }  

    if(this.provider === this.enumProviderTypes.Pelecard){
      
      this.form = this.fb.group({
        "PaymentRequestID":  [this.prePaymentData.PaymentRequestID],
        "Provider": [this.prePaymentData.Provider],
        "ProviderName": [this.prePaymentData.ProviderName],
        "EntityID": [this.prePaymentData.EntityID, Validators.required],
        "EntityType": [this.prePaymentData.EntityType, Validators.required],
        "BranchID":[this.prePaymentData.BranchID, Validators.required],
        "CurrencyID": [this.prePaymentData.CurrencyID],
        "CurrencyRate":[this.prePaymentData.CurrencyRate],
        "SumOfProductsSelected": [this.prePaymentData.SumOfProductsSelected],
        "TerminalID":[this.prePaymentData.TerminalID, Validators.required],
        "PaymentBoxID": [this.prePaymentData.PaymentBoxID],
        "Total": [total,  Validators.compose([Validators.required, Validators.min(0.01), Validators.max(99999.99)])],        
        "MaxNumberOfPayments": [this.prePaymentData.MaxNumberOfPayments, Validators.compose([Validators.required, Validators.min(1), Validators.max(48)])],
        "BitAuthenticationDataID": [this.bitAuthDataID]
        
      });
    }
    else if(this.provider === this.enumProviderTypes.Bit){
      
      this.form = this.fb.group({
        "PaymentRequestID":  [this.prePaymentData.PaymentRequestID],
        "Provider": [this.prePaymentData.Provider],
        "ProviderName": [this.prePaymentData.ProviderName],
        "EntityID": [this.prePaymentData.EntityID, Validators.required],
        "EntityType": [this.prePaymentData.EntityType, Validators.required],
        "BranchID":[this.prePaymentData.BranchID, Validators.required],
        "CurrencyID": [this.prePaymentData.CurrencyID],
        "CurrencyRate":[this.prePaymentData.CurrencyRate],
        "SumOfProductsSelected": [this.prePaymentData.SumOfProductsSelected],
        "TerminalID":[this.prePaymentData.TerminalID], // in the future there will be no terminal
        "PaymentBoxID": [this.prePaymentData.PaymentBoxID],
        "Total": [total,  Validators.compose([Validators.required, Validators.min(0.01), Validators.max(99999.99)])],        
        "MaxNumberOfPayments": [this.prePaymentData.MaxNumberOfPayments],
        "BitAuthenticationDataID": [this.bitAuthDataID]           
      });
    }

    
  }

  ngOnDestroy(){
    //this.sub.unsubscribe();
  }

  previousPage(){
    this.router.navigate(['scheduler']);
  }

 

  onPriceChange(event){
    // round number
    this.f.Total.setValue(this.roundPrice(this.f.Total.value));
  }

  roundPrice(val) {
    val = val || 0;
    return (Math.round((val + Number.EPSILON) * 100) / 100).toFixed(2);
  }



  getFormValidationErrors() {
    return Utils.getFormValidationErrors(this.form);

  }


  public onCancel(event){    
    this.router.navigate(['/scheduler']);
  }

  public onSubmit(values: any): void {
    
    try {     
        
      if (this.form.valid) {
        if(this.submitting){
          return;
        }
        this.submitting = true;  
  
        if(this.f.Provider.value === this.enumProviderTypes.Pelecard){
          this.prePaymentData.TerminalID = this.f.TerminalID.value;
          this.prePaymentData.PaymentBoxID = this.f.PaymentBoxID.value;
          this.prePaymentData.Total = this.f.Total.value;
          this.prePaymentData.MaxNumberOfPayments = this.f.MaxNumberOfPayments.value;
        }
        else
        {
          this.prePaymentData.Total = this.f.Total.value; 
          this.prePaymentData.MaxNumberOfPayments = this.f.MaxNumberOfPayments.value;
          this.prePaymentData.BitAuthenticationDataID = this.f.BitAuthenticationDataID.value;      
        }
  
        this.receivePaymentModel.PrePaymentRequestModel = JSON.stringify(this.prePaymentData);
        
  
        this.paymentService.postPrePaymentRequest(this.receivePaymentModel).subscribe(result => {
          this.submitting = false;
          if(result.Code === ApiResponseCode.Success){
            //PAYMENT-REQUEST-SENT-SUCCESSFULLY
            var msg = this.translate.instant('PAYMENT.PAYMENT-REQUEST-SENT-SUCCESSFULLY');
            this.openSnackBar(msg);
            this.previousPage();
          }
          else{
            this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
          }
  
        }, error=> {          
          this.submitting = false;
          this.error = error;
        });
      }

    } catch (error) {
      this.error = error;
      this.submitting = false;
    }
  }

  openSnackBar(message:string) {

    this.toastMsg.showSuccess(message);
  }

}
